import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-banner',
	standalone: true,
	imports: [MatIconModule],
	templateUrl: './banner.component.html',
	styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
	@Input() message = '';
	@Input() icon = 'check';
	@Input() variant: 'success' | 'error' = 'success';
}
